import { Tables } from "database.types";
import { fetchApi } from "./base";
import { WatchlistItem } from "@/types/watchlist";

export function addToWatchlist(variantId: number, scanned: boolean) {
  return fetchApi<never>(`/api/watchlist`, {
    method: "POST",
    body: {
      variantId: variantId,
      scanned: scanned,
    },
  });
}

export function getSharedWatchlist(userId: string) {
  return fetchApi<{
    success: boolean;
    data: Array<WatchlistItem>;
  }>(`/api/watchlist/shared/${userId}`, {
    method: "GET",
  });
}

export function getWatchlist() {
  return fetchApi<{
    success: boolean;
    data: Array<WatchlistItem>;
  }>(`/api/watchlist`, {
    method: "GET",
  });
}

export function removeFromWatchlist(variantId: number) {
  return fetchApi<never>(`/api/watchlist/${variantId}`, {
    method: "DELETE",
  });
}

export function sortWatchlist(
  watchlist: Array<{ variantId: number; position: number }>,
) {
  return fetchApi<never>(`/api/watchlist/sort`, {
    method: "POST",
    body: watchlist,
  });
}
